import { LitElement, html, css } from 'lit';
import tracking from '@finn-no/analytics';
import pulse from '@finn-no/pulse-sdk';
import { i18n } from '@lingui/core';

class MFPB2b extends LitElement {
    static properties = {
        market: { attribute: true, type: String },
    };

    static styles = css`
        :host {
            display: block;
        }
    `;

    connectedCallback() {
        super.connectedCallback();

        const locale = this.getAttribute('locale');
        const messages = JSON.parse(this.getAttribute('messages') || '{}');

        i18n.load(locale, messages);
        i18n.activate(locale);

        pulse.trackPageView({
            object: {
                type: 'MarketFrontpage',
            },
            vertical: {
                name: 'b2b',
            },
        });

        tracking.trackPage({});

        if (navigator.serviceWorker) {
            navigator.serviceWorker.register('/sw.js').catch(() => {});
        }
    }

    render() {
        return html`
            <link
                rel="stylesheet"
                type="text/css"
                href="https://assets.finn.no/pkg/@fabric-ds/css/v1/fabric.min.css"
            />
            <a
                href="#market-start"
                class="skiplink absolute top left opacity-0 bg-milk pv-5 ph-10 -z-1"
                >${i18n.t({
                    id: 'b2b.skiplink',
                    message: 'Go to main content',
                    comment:
                        'skiplink used for keyboard navigators to jump to main content on page',
                })}
            </a>
            <slot name="topbar"></slot>
            <slot name="banner"></slot>
            <main class="page-container pt-16" style="min-height: 60vh">
                <slot name="broadcast"></slot>
                <header class="flex items-center mb-16">
                    <span class="text-aqua-400 mr-8">
                        <slot name="icon"></slot>
                    </span>
                    <h1
                        class="h2 mb-0"
                        data-automation-id="marketTitle"
                        id="market-start"
                    >
                        ${this.market}
                    </h1>
                </header>
                <div class="lg:grid f-grid lg:grid-cols-3">
                    <div class="lg:col-span-2 -ml-16">
                        <slot name="global-search"></slot>
                    </div>
                    <div class="lg:col-span-2 -ml-16">
                        <slot name="links"></slot>
                    </div>
                    <div class="mb-32">
                        <slot name="last-search"></slot>
                    </div>
                </div>

                <slot name="recommendations"></slot>
            </main>
            <slot name="footer"></slot>
        `;
    }
}

customElements.define('mfp-b2b', MFPB2b);
